var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{attrs:{"value":_vm.error,"type":"error","text":""}},[_vm._v(" "+_vm._s(_vm.text)+" "),_vm._l((_vm.validationErrors),function(e){return _c('p',{key:e},[_vm._v(" "+_vm._s(e)+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }